import * as d3 from 'd3';

interface HistogramAnnotationsProps {
  chartGroup: d3.Selection<SVGGElement, unknown, null, undefined>;
  showAnnotations?: {
    mean?: boolean;
    median?: boolean;
  };
  allData: number[];
  orientation: 'vertical' | 'horizontal';
  currentXScale: d3.ScaleLinear<number, number>;
  currentYScale: d3.ScaleLinear<number, number>;
  innerWidth: number;
  innerHeight: number;
}

/**
 * 統計量アノテーションを描画する関数
 */
export const renderHistogramAnnotations = ({
  chartGroup,
  showAnnotations,
  allData,
  orientation,
  currentXScale,
  currentYScale,
  innerWidth,
  innerHeight
}: HistogramAnnotationsProps): void => {
  // 既存のアノテーションを削除
  chartGroup.selectAll('.annotation-line').remove();
  chartGroup.selectAll('.annotation-label').remove();

  if (!showAnnotations || !allData || allData.length === 0) {
    return;
  }

  const annotationData: { value: number; label: string; strokeDasharray: string }[] = [];

  if (showAnnotations.mean) {
    const mean = d3.mean(allData);
    if (mean !== undefined) {
      annotationData.push({ value: mean, label: `Mean: ${mean.toFixed(2)}`, strokeDasharray: 'none' });
    }
  }

  if (showAnnotations.median) {
    const median = d3.median(allData);
    if (median !== undefined) {
      annotationData.push({ value: median, label: `Median: ${median.toFixed(2)}`, strokeDasharray: '4,4' });
    }
  }

  annotationData.forEach((annotation) => {
    if (orientation === 'horizontal') {
      // 水平方向: Y軸上に線を描画
      const yPos = currentYScale(annotation.value);

      // 線
      chartGroup.append('line')
        .attr('class', 'annotation-line')
        .attr('x1', 0)
        .attr('x2', innerWidth)
        .attr('y1', yPos)
        .attr('y2', yPos)
        .attr('stroke', '#ff6b6b')
        .attr('stroke-width', 2)
        .attr('stroke-dasharray', annotation.strokeDasharray)
        .attr('opacity', 0.7);

      // ラベル
      chartGroup.append('text')
        .attr('class', 'annotation-label')
        .attr('x', innerWidth - 5)
        .attr('y', yPos - 5)
        .attr('text-anchor', 'end')
        .style('font-size', '11px')
        .style('font-weight', 'bold')
        .style('fill', '#ff6b6b')
        .text(annotation.label);
    } else {
      // 垂直方向: X軸上に線を描画
      const xPos = currentXScale(annotation.value);

      // 線
      chartGroup.append('line')
        .attr('class', 'annotation-line')
        .attr('x1', xPos)
        .attr('x2', xPos)
        .attr('y1', 0)
        .attr('y2', innerHeight)
        .attr('stroke', '#ff6b6b')
        .attr('stroke-width', 2)
        .attr('stroke-dasharray', annotation.strokeDasharray)
        .attr('opacity', 0.7);

      // ラベル
      chartGroup.append('text')
        .attr('class', 'annotation-label')
        .attr('x', xPos + 5)
        .attr('y', 15)
        .attr('text-anchor', 'start')
        .style('font-size', '11px')
        .style('font-weight', 'bold')
        .style('fill', '#ff6b6b')
        .text(annotation.label);
    }
  });
};
